export enum ProductIdentificationEnum {
  GTIN = 'gtin',
  MANUFACTURER_WITH_CODE = 'manufacturer_with_code'
}
